class HflCardQuickShop extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;
    const form = this.querySelector('[data-hfl-card-quick-shop-form]');
    const component = this.querySelector('product-form-component');
    const purchaseButtons = Array.from(this.querySelectorAll('[data-hfl-card-purchase]'));

    this.querySelectorAll('[data-hfl-card-variant]').forEach((button) => {
      button.addEventListener('click', () => {
        const variantInput = form?.querySelector('input[name="id"]');
        const quantityInput = form?.querySelector('input[name="quantity"]');
        const quantity = button.dataset.quantity || '1';

        if (variantInput) variantInput.value = button.dataset.variantId || '';
        if (quantityInput) quantityInput.value = quantity;
        if (component) component.dataset.quantityDefault = quantity;
      }, { signal });
    });

    let activeButton;
    let activeLabel;
    let defaultLabel = '';
    let resetTimer;

    form?.addEventListener('submit', (event) => {
      activeButton = event.submitter?.closest('[data-hfl-card-purchase]');
      if (!activeButton) return;

      activeLabel = activeButton.querySelector('[data-hfl-card-purchase-label]');
      defaultLabel = activeLabel?.textContent || '';
      purchaseButtons.forEach((button) => { button.disabled = true; });
      if (activeLabel) activeLabel.textContent = 'Adding…';
    }, { signal });

    const finish = (message) => {
      window.clearTimeout(resetTimer);
      if (activeLabel) activeLabel.textContent = message;

      resetTimer = window.setTimeout(() => {
        purchaseButtons.forEach((button) => { button.disabled = false; });
        if (activeLabel) activeLabel.textContent = defaultLabel;
        activeButton = undefined;
        activeLabel = undefined;
      }, 1600);
    };

    component?.addEventListener('cart:update', () => finish('Added'), { signal });
    component?.addEventListener('cart:error', () => finish('Try again'), { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }
}

if (!customElements.get('hfl-card-quick-shop')) {
  customElements.define('hfl-card-quick-shop', HflCardQuickShop);
}
